import { Toaster } from 'sonner';

export const AppToastContainer = () => {
  return (
    <Toaster closeButton richColors position="top-right" expand duration={3500}/>
  )
}